export const OneDriveFileProviderDisplayName = "okc";
export const OneDriveConsumerFileProviderDisplayName = "pkc";
export default {OneDriveFileProviderDisplayName,OneDriveConsumerFileProviderDisplayName};